const doc = [({"ja":({"enterPassportInformation":"パスポート情報を入力する"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;